<div
  [class.top-box]="isTopBox"
  #mainBox
  [class.bottom-box]="isBottomBox"
  [class.data-recorded-success]="justRecorded"
  [class.data-buffer-active]="addingBehaviorData"
  class="pointer data-entry-box"
  (click)="clickedBox()"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
>
  <div
    class="flag no-select"
    (mousedown)="startLongPress()"
    (mouseup)="endLongPress($event)"
    (mouseleave)="endLongPress($event)"
    (touchstart)="startLongPress()"
    (touchend)="endLongPress($event)"
    (touchcancel)="endLongPress($event)"
  >
    <span *ngIf="!isEditing" class="flag-text">{{ text }}</span>
    <span *ngIf="isEditing">{{ sessionValue }}</span>
    <span *ngIf="!isEditing" class="badge badge-right">{{ sessionValue }}</span>
    <span *ngIf="!isEditing && showDayValue" class="badge badge-left">{{
      dayValue + sessionValue
    }}</span>
    <button
      *ngIf="isEditing"
      class="flag-button top-left green"
      (click)="decreaseSessionValue()"
    >
      -
    </button>
    <button
      *ngIf="isEditing"
      class="flag-button bottom-right red"
      (click)="increaseSessionValue()"
    >
      +
    </button>
    <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
  </div>
  <div
    class="data-entry-cooldown-bar"
    [class.data-entry-cooldown-active]="addingBehaviorData"
    aria-hidden="true"
  >
    <div class="data-entry-cooldown-bar-fill"></div>
  </div>
</div>
@if (detailsOpened) {
<app-target-details
  [behavior]="behavior"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}
<div
  class="extra-container extra-big abc-container"
  #extraBox
  [class.hide]="!extraOpened"
>
  <button class="abc-add-button-duration" (click)="openBulk()">
    + Bulk Add
  </button>
  <app-abc-data-panel
    #abcDataPanel
    [behaviorID]="behaviorID"
    [sessionValue]="sessionValue"
    (setExtraBoxesEvent)="setExtraBoxes()"
    [behaviorType]="behaviorType"
  ></app-abc-data-panel>
</div>

<div
  class="extra-container extra-big abc-container"
  #extraBox3
  [class.hide]="!extra3Opened"
>
  <div class="extra-close" (click)="closeExtra3()">X</div>
  <div class="extra-container-textbox abc-container-textbox">
    <div class="abc-card">
      <div class="abc-card-content">
        <div class="abc-item-row" style="font-size: 18px; font-weight: bold">
          Add Bulk Entries
        </div>
        <div class="abc-item-row">
          <div class="abc-item" [style.background-color]="'#5d87b5'">
            <div class="abc-item-name">Start Date/Time</div>
          </div>
          <div class="abc-item-value">
            <input
              class="form-control"
              type="datetime-local"
              [(ngModel)]="bulkStart"
            />
          </div>
        </div>
        <div class="abc-item-row">
          <div class="abc-item" [style.background-color]="'#5d87b5'">
            <div class="abc-item-name">End Date/Time</div>
          </div>
          <div class="abc-item-value">
            <input
              class="form-control"
              type="datetime-local"
              [(ngModel)]="bulkEnd"
            />
          </div>
        </div>
        <div class="abc-item-row">
          <div class="abc-item" [style.background-color]="'#68a1b7'">
            <div class="abc-item-name">Occurrences</div>
          </div>
          <div class="abc-item-value">
            <input
              class="form-control"
              type="number"
              min="1"
              [(ngModel)]="bulkOccurrences"
            />
          </div>
        </div>

        <div class="abc-item-row">
          <div class="abc-item" [style.background-color]="'#68a1b7'">
            <div class="abc-item-name">Has ABC data?</div>
          </div>
          <div class="abc-item-value">
            <input
              class="form-check-input"
              style="width: 20px; height: 20px"
              type="checkbox"
              [(ngModel)]="hasABCData"
            />
          </div>
        </div>

        <div class="abc-item-row">
          <button class="abc-add-button-duration" (click)="addBulkFrequency()">
            Add {{ bulkOccurrences ?? "" }} Entries
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
